export const state = () => ({
	partner_universities: null,
	university_degrees: null,
	faculties: null,
	university_faculties: null,
	faculty_field_of_interests: null,
	industries: null,
	fields_of_interest: null,
});

export const mutations = {
	setPartnerUniversities(state: any, payload: any) {
		state.partner_universities = payload;
	},
	setUniversityDegrees(state: any, payload: any) {
		state.university_degrees = payload;
	},
	setFaculties(state: any, payload: any) {
		state.faculties = payload;
	},
	setUniversityFaculties(state: any, payload: any) {
		state.university_faculties = payload;
	},
	setFacultyFieldOfInterests(state: any, payload: any) {
		state.faculty_field_of_interests = payload;
	},
	setIndustries(state: any, payload: any) {
		state.industries = payload;
	},
	setFieldsOfInterest(state: any, payload: any) {
		state.fields_of_interest = payload;
	},
};

export const getters = {
	getPartnerUniversities: (state: any) => state.partner_universities,
	getUniversityDegrees: (state: any) => state.university_degrees,
	getFaculties: (state: any) => state.faculties,
	getUniversityFaculties: (state: any) => state.university_faculties,
	getFacultyFieldOfInterests: (state: any) =>
		state.faculty_field_of_interests,
	getIndustries: (state: any) => state.industries,
	getFieldsOfInterest: (state: any) => state.fields_of_interest,
};

export const actions = {
	async getPartnerUniversities(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/partners')
				.then((res) => {
					state.commit('setPartnerUniversities', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getUniversityDegrees(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('api/dd/universities/' + payload + '/degrees')
				.then((res) => {
					state.commit('setUniversityDegrees', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getFaculties(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('api/dd/faculties')
				.then((res) => {
					state.commit('setFaculties', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getUniversityFaculties(state: any, university_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(`api/dd/universities/${university_uuid}/faculties`)
				.then((res) => {
					state.commit('setUniversityFaculties', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getFacultyFieldOfInterests(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('api/dd/faculties/' + payload + '/fields-of-interest')
				.then((res) => {
					state.commit('setFacultyFieldOfInterests', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getIndustries(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('api/industries')
				.then((res) => {
					state.commit('setIndustries', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getFieldsOfInterest(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(`api/industries/${payload}/fields-of-interest`)
				.then((res) => {
					state.commit('setFieldsOfInterest', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateFieldsOfInterest(state: any, payload: any) {
		state.commit('setFieldsOfInterest', payload);
	},

	resetFacultyFieldsOfInterest(state: any) {
		state.commit('setFacultyFieldOfInterests', null);
	},
};
